import gettext from '@sdk/lang/gettext';
import ToastComponent from '@sdk/common/toast/ToastComponent';
import { Feature } from '@sdk/common/features';
import { SUBSCRIPTION_NAMES } from '@sdk/account/constants';
import useAuth from '@sdk/authentication/useAuth';
import getAuthConfig from '@sdk/api/utils/getAuthConfig';
import getRequestUrl from '@sdk/api/utils/getRequestUrl';

import BodyPortal from '@web/components/BodyPortal';
import PremiumGuard from '@web/premiumGuard/PremiumGuard';

import { TextButton } from './exportButton.styles';
import { useExportButton } from './exportButtons.hooks';

type Props = {
  getData: () => Promise<{
    header: string[];
    body: string[][];
  }>;
  format: string;
  filename?: string;
  text: string;
};

const ExportButton = ({ getData, format, filename, text }: Props) => {
  const { orgSettings, isOrgFeatureEnabled } = useAuth();
  const url = getRequestUrl('export', {});
  const authToken = getAuthConfig();

  const { submit, formRef } = useExportButton({
    getData,
    isOrgFeatureEnabled,
  });

  return (
    <>
      <PremiumGuard
        premiumFeature={Feature.fileExport}
        hasAccess={isOrgFeatureEnabled(Feature.fileExport)}
        tooltipContent={gettext('Available in %(subscriptionName)s', {
          subscriptionName: SUBSCRIPTION_NAMES[orgSettings.premiumFeatures[Feature.fileExport]],
        })}>
        <TextButton onClick={() => submit()}>{text}</TextButton>
      </PremiumGuard>
      <ToastComponent />
      <BodyPortal>
        <form action={url} method="post" target="_blank" noValidate hidden ref={formRef}>
          <textarea name="data" readOnly hidden></textarea>
          <input name="filename" type="hidden" value={filename} />
          <input name="format" type="hidden" value={format} />
          <input name="Authorization" type="hidden" value={authToken} />
        </form>
      </BodyPortal>
    </>
  );
};

export default ExportButton;
